<template>
  <div class="col-12">
    <div class="bg-white default-border-radius mb-2" :class="expanded ? 'border border-primary' : ''">

      <q-expansion-item v-model="expanded" expand-icon-class="hidden">
        <template v-slot:header class="row w-100">

          <div class="row w-100 p-0">
            <div
                class="col-4 font-weight-bold text-left tw-formattedNumberFont d-flex align-items-center">
              {{ $t(`demand.product.services.names.finance_ASSUR_DEC`) }}
            </div>
            <div
                class="col-5 font-weight-bold text-right tw-formattedNumberFont d-flex align-items-center justify-content-end">
              {{ amountHT }}
            </div>
            <div
                class="col-3 font-weight-bold text-right tw-formattedNumberFont d-flex align-items-center justify-content-end">
              {{ amountTTC }}
            </div>
          </div>
        </template>
        <div class="card-body" :class="expanded ? 'bg-secondary border-top border-primary' : 'bg-white'">
          <div class="d-flex justify-between align-items-center">
            <div class="">
              <label class="text-bold mb-0">Détails Assurances</label>
            </div>
          </div>
          <q-table class="my-sticky-header-last-column-table bg-transparent border-0 tw-Assurance-table" flat
                   bordered title="" :rows="data.beneficiaries" :columns="columns" row-key="name" hide-pagination>
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                  <template v-if="col.name !== 'selected'">{{ $t(col.label) }}</template>
                </q-th>
              </q-tr>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                  <div v-if="col.name === 'partyName'">
                    <span class="ml-1">{{ col.value }}</span>
                  </div>

                  <q-input v-model="props.row[col.name]" v-if="col.editable && col.name !== 'coverage'" disable />
                  <div v-if="col.editable && col.name === 'coverage'" class="form-control no-border p-0"
                       style="max-width: 65px;float: right;">
                    <q-input :model-value="props.row[col.name]" disable
                             class="flex-fill m-0" outlined dense input-class="text-right">
                      <template v-slot:append>
                        <span class="input-suffix">%</span>
                      </template>
                    </q-input>


                  </div>
                  <span v-if="c">{{ col.value  }}</span>
                  <span v-if="!col.editable && col.type !== 'boolean' && col.name !== 'partyName'">{{ col.value }}</span>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
      </q-expansion-item>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import {formatAmoutswitchCurrency} from "@/utils/configuration/formatters-config";
import {globalConfig} from "@/utils";

@Options({
  props: ["data"],
})
export default class SummaryFinancingPartyInsurance extends Vue {

  expanded = true;

  data?: any;

  get columns() {
    return globalConfig.table_config.partyInsuranceCol;
  }

  get amountHT() {
    const amount = this.data.amountValueWoTax
    return `${formatAmoutswitchCurrency("EUR", amount)} ${this.data.paymentDatesOption === "INSTALLMENT" ? "/Mois" : "HT"}`
  }

  get amountTTC() {
    const amount = this.data.amountValueWTax
    return `${formatAmoutswitchCurrency("EUR", amount)} ${this.data.paymentDatesOption === "INSTALLMENT" ? "/Mois" : "TTC"}`
  }


}
</script>

<style lang="scss" scoped></style>
